const gRecaptchaResponseName = "g-recaptcha-response";

const publicVariables = {
  GRECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_GRECAPTCHA_SITE_KEY,
  MAPBOX_STYLE_USERNAME: process.env.NEXT_PUBLIC_MAPBOX_STYLE_USERNAME,
  MAPBOX_STYLE_ID: process.env.NEXT_PUBLIC_MAPBOX_STYLE_ID,
  MAPBOX_STYLE_ACCESS_TOKEN: process.env.NEXT_PUBLIC_MAPBOX_STYLE_ACCESS_TOKEN,
} as const;

const publicEnv = (name: keyof typeof publicVariables): string => {
  const value = publicVariables[name];
  if (!value) {
    throw new Error(`Could not find environment variable: ${name}`);
  }

  return value;
};

export { gRecaptchaResponseName, publicEnv, publicVariables };
